// jscs:disable requireCamelCaseOrUpperCaseIdentifiers

import client from "./descriptors/client";
import user_sub from "./descriptors/user_sub";
import user from "./descriptors/user";
import change_password from "./descriptors/change_password";
import simplified_user from "./descriptors/simplified_user";
import token from "./descriptors/token";
import user_grant from "./descriptors/user_grant";
import user_email from "./descriptors/user_email";
import user_alias from "./descriptors/user_alias";
import reset_password from "./descriptors/reset_password";
import ldap_auth from "./descriptors/ldap_auth";
import client_role_mapping_rule from "./descriptors/client_role_mapping_rule";
import managed_user from "./descriptors/managed_user";

const descriptors = {
    client,
    user_sub,
    user,
    simplified_user,
    change_password,
    token,
    user_grant,
    user_email,
    user_alias,
    reset_password,
    ldap_auth,
    client_role_mapping_rule,
    managed_user,
};

export type ResourceName = keyof typeof descriptors;

export default descriptors;
